import { render } from "./EmergencyContactList.vue?vue&type=template&id=00239146&scoped=true&ts=true"
import script from "./EmergencyContactList.vue?vue&type=script&lang=ts"
export * from "./EmergencyContactList.vue?vue&type=script&lang=ts"

import "./EmergencyContactList.vue?vue&type=style&index=0&id=00239146&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00239146"]])

export default __exports__